import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { appConfigs } from "../../../martin/_helpers";
import CircularProgress from '@material-ui/core/CircularProgress';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as commonActions from "../../redux/commonActions";
import { resendVerification, verifyEmail } from "../../redux/commonCrud";
import Alert from '@material-ui/lab/Alert'; // https://material-ui.com/components/alert/#simple-alerts

export default function Account() {
    let { hex, action } = useParams();
    // document.title = "Account — " + appConfigs.app_name;
    const [alert, setAlert] = useState(null);
    const dispatch = useDispatch();
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        if (action === "resend-verification") document.title = "Resend Verification — " + appConfigs.app_name;
        if (action === "verify-email") document.title = "Verify Email — " + appConfigs.app_name;
        dispatch(commonActions.fetchAccount({ user_hex: hex }));
    }, [dispatch, hex, action]);

    const { accountLoading, account } = useSelector(
        (state) => ({
            accountLoading: state.account.actionsLoading,
            account: state.account.data,
        }),
        shallowEqual
    );

    useEffect(() => {
        if (action === "resend-verification") {
            if (account?.is_blocked === "0" && account?.is_deleted === "0" && account?.is_email_verified === "0") {
                setProcessing(true);
                resendVerification({ data: { user_hex: hex } })
                    .then((resp) => {
                        console.log(resp.data);
                        if (resp.data.response_code === 1) {
                            setAlert({ type: 'success', msg: resp.data.description });
                        } else {
                            setAlert({ type: 'error', msg: resp.data.description });
                        }
                        setProcessing(false);
                    })
                    .catch(() => {
                        setAlert({ type: 'error', msg: `An error occurred. Please refresh page to try again.` });
                        setProcessing(false);
                    });
            } else {
                setAlert({ type: "error", msg: `Sorry, a verification code couldn't be send to <strong>${account?.email}</strong> at the moment. Please try again.` });
            }
        } else if (action === "verify-email") {
            if (account?.is_blocked === "0" && account?.is_deleted === "0" && account?.is_email_verified === "0") {
                setProcessing(true);
                verifyEmail({ data: { user_hex: hex, verification_code: account?.verification_code } })
                    .then((resp) => {
                        console.log(resp.data);
                        if (resp.data.response_code === 1) {
                            setAlert({ type: 'success', msg: `Success! Your email <strong>${account?.email}</strong> was verified successfully. You can now log in <a href="/">from here</a>.` });
                        } else {
                            setAlert({ type: 'error', msg: `Sorry, a critical error occurred while verifying <strong>${account?.email}</strong>. Please try again.` });
                        }
                        setProcessing(false);
                    })
                    .catch(() => {
                        setAlert({ type: 'error', msg: `Sorry, a critical error occurred while verifying <strong>${account?.email}</strong>. Please try again.` });
                        setProcessing(false);
                    });
            } else {
                setAlert({ type: "error", msg: `Sorry, a critical error occurred while verifying <strong>${account?.email}</strong>. Please try again.` });
            }
        } else {
            setAlert({ type: "error", msg: `Sorry, a critical error occurred while processing your request. Please try again.` });
        }
    }, [action, account, hex]);

    return (
        <>
            <div className="martin-narrow-content content-section">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row row-bottom-padded-sm">
                            <div className="col-md-12">
                                {(action === "resend-verification") && <>
                                    <div className="text-center" style={{ margin: '40px 0' }}>
                                        <span className="heading-meta">Resend Verification</span>
                                        {(accountLoading || processing) && <>
                                            <CircularProgress color="secondary" />
                                            <p><small>Processing, please wait.</small></p>
                                        </>}
                                        {(alert && !accountLoading && !processing) && <Alert severity={alert.type} style={{ marginBottom: '20px' }}><div dangerouslySetInnerHTML={{ __html: alert.msg }} /></Alert>}
                                    </div>
                                </>}
                                {(action === "verify-email") && <>
                                    <div className="text-center" style={{ margin: '40px 0' }}>
                                        <span className="heading-meta">Verify Email</span>
                                        {(accountLoading || processing) && <>
                                            <CircularProgress color="secondary" />
                                            <p><small>Processing, please wait.</small></p>
                                        </>}
                                        {(alert && !accountLoading && !processing) && <Alert severity={alert.type} style={{ marginBottom: '20px' }}><div dangerouslySetInnerHTML={{ __html: alert.msg }} /></Alert>}
                                    </div>
                                </>}
                                {/* <div className="about-desc">
                                    <span className="heading-meta">My Account</span>
                                    <h2 className="martin-heading">Account</h2>

                                    <p>I specialise in creating bespoke marketing information sites and small e-commerce (shop) websites. Tailored to marketing or selling your products/services successfully online.</p>
                                
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}